import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { i18n, getLocale } from 'core/i18n';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Table from 'components/table';
import InputField from 'components/inputField';
import Select from 'components/reactSelect';
import DatePicker from 'components/datePicker';
import Button from 'components/button';
import Dialog from 'components/dialog';
import Format from 'core/format';
import moment from 'moment';
import './styles/bookings.css';
import { searchBookings, cleanBookings, getBooking, cleanBookingData, getBookingPDF, getPortalToken, HOME_GET_BOOKING_DATA_SUCCESS } from './action';

class BookingsControl extends Component {
  constructor(props) {
    super(props);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.creatColumns = this.creatColumns.bind(this);
    this.onSearchBookings = this.onSearchBookings.bind(this);
    this.handleDatePlus = this.handleDatePlus.bind(this);
    this.state = {
      tabValue: 0,
      tablePage: 0,
      rowsPerPage: 10,
      openBookingDialog: false,
      bookingReferenceError: null,
    };
  }

  handleTabChange(event, newValue) {
    const { props, onSearchBookings } = this,
      { dispatch } = props;
    this.setState(
      {
        tabValue: newValue,
      },
      () => {
        if (newValue === 0) {
          dispatch(cleanBookings());
        } else {
          onSearchBookings();
        }
      }
    );
  }

  handleChangePage(event, newPage) {
    this.setState({
      tablePage: newPage,
    });
  }

  handleChangeRowsPerPage(event) {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      tablePage: 0,
    });
  }

  creatColumns() {
    const { props } = this,
      { dispatch } = props;
    const columns = [
      {
        id: 'bookingReference',
        label: i18n('pnr'),
        minWidth: 30,
        align: 'left',
        format: (value) => {
          return <div key={value}>{value}</div>;
        },
      },
      {
        id: 'bookingDate',
        label: i18n('booking_date'),
        minWidth: 40,
        align: 'center',
        format: (value) => {
          return value ? moment(value).format('YYYY/MM/DD') : '';
        },
      },
      {
        id: 'holdDate',
        label: i18n('hold_date'),
        minWidth: 40,
        align: 'center',
        format: (value) => {
          if (value) {
            return value.substr(0, 4) === '9999' ? '-' : value;
          } else {
            return '';
          }
        },
      },
      {
        id: 'departureDate',
        label: i18n('departure_date'),
        minWidth: 40,
        align: 'center',
        format: (value) => {
          return value ? moment(value).format('YYYY/MM/DD') : '';
        },
      },
      {
        id: 'bookingStatus',
        label: i18n('status'),
        minWidth: 30,
        align: 'center',
        format: (value) => {
          return value;
        },
      },
      {
        id: 'event',
        label: i18n('execute'),
        minWidth: 40,
        align: 'center',
        format: (value) => {
          return value ? (
            <div key={value}>
              <img
                alt=''
                src={require('assets/images/take-look.svg')}
                className='bookings-event-img'
                onClick={() => {
                  dispatch(getBooking(value.bookingReference));
                }}
              />
              {value.editable ? (
                <img
                  alt=''
                  src={require('assets/images/edit.svg')}
                  className='bookings-event-img'
                  onClick={() => {
                    dispatch(getPortalToken(value.bookingReference, 'mmb'));
                  }}
                />
              ) : null}
              {value.printable ? (
                <img
                  alt=''
                  src={require('assets/images/printer.svg')}
                  className='bookings-event-img'
                  onClick={() => {
                    dispatch(getBookingPDF(value.bookingReference, getLocale()));
                  }}
                />
              ) : null}
            </div>
          ) : (
            ''
          );
        },
      },
    ];
    return columns;
  }

  onSearchBookings() {
    const { props, state, refs } = this,
      { dispatch } = props,
      { tabValue } = state,
      { bookingsPnrCode, bookingsArrivalStation, bookingsDate, bookingsAgentId } = refs;
    switch (tabValue) {
      case 0:
        if (bookingsPnrCode.getValue() && bookingsPnrCode.getValue().length !== 6) {
          this.setState({ bookingReferenceError: i18n('error_pnr_six_length') });
          return;
        }
        dispatch(
          searchBookings(
            {
              type: 0,
              page: 1,
              pageSize: 9999,
              bookingReference: bookingsPnrCode.getValue(),
              destination: bookingsArrivalStation.getValue() ? bookingsArrivalStation.getValue().value : '',
              bookingDate: bookingsDate.getValue().selectedDay,
              agentId: bookingsAgentId.getValue() ? bookingsAgentId.getValue().value : '',
            },
            tabValue
          )
        );
        break;
      case 1:
        dispatch(
          searchBookings(
            {
              type: 1,
              page: 1,
              pageSize: 9999,
              bookingReference: '',
              destination: '',
              bookingDate: '',
              agentId: '',
            },
            tabValue
          )
        );
        break;
      case 2:
        dispatch(
          searchBookings(
            {
              type: 2,
              page: 1,
              pageSize: 9999,
              bookingReference: '',
              destination: '',
              bookingDate: '',
              agentId: '',
            },
            tabValue
          )
        );
        break;
      case 3:
        dispatch(
          searchBookings(
            {
              type: 3,
              page: 1,
              pageSize: 9999,
              bookingReference: '',
              destination: '',
              bookingDate: '',
              agentId: '',
            },
            tabValue
          )
        );
        break;
      default:
        break;
    }
    this.setState({ bookingReferenceError: null });
  }

  handleDatePlus(depDate, arrDate) {
    let datePlus = 0;
    datePlus = Format.countTime('d', depDate.substr(0, 10), arrDate.substr(0, 10));
    if (datePlus > 0) {
      return (
        <div style={{ display: 'inline-block' }}>
          {moment(arrDate.split('+')[0]).format('HH:mm')}
          <span className='bookings-confirmation-date-plus'>{`+${datePlus}`}</span>
        </div>
      );
    } else {
      return <div style={{ display: 'inline-block' }}>{moment(arrDate.split('+')[0]).format('HH:mm')}</div>;
    }
  }

  componentDidUpdate(prevProps) {
    const self = this,
      { props } = self,
      { state } = props;
    if (prevProps.state.action !== state.action) {
      switch (state.action) {
        case HOME_GET_BOOKING_DATA_SUCCESS:
          this.setState({
            openBookingDialog: true,
          });
          break;
        default:
          break;
      }
    }
  }

  componentWillUnmount() {
    const { props } = this,
      { dispatch } = props;
    dispatch(cleanBookings());
  }

  render() {
    const self = this,
      { props, state: _state, handleTabChange, handleChangePage, handleChangeRowsPerPage, creatColumns, onSearchBookings, handleDatePlus } = self,
      { state, dispatch, flightOptionObject, agentList, translationData } = props,
      { bookingRows, bookingData } = state,
      { tabValue, tablePage, rowsPerPage, openBookingDialog, bookingReferenceError } = _state;

    const tabs = [i18n('search_pnr'), i18n('bookings_paid'), i18n('bookings_on_hold'), i18n('bookings_past')];

    return (
      <div className='bookings-frame'>
        <Tabs value={tabValue} onChange={handleTabChange} className='bookings-tabs' variant='scrollable' scrollButtons='auto'>
          {tabs.map((item, index) => {
            return (
              <Tab
                key={index}
                label={item}
                disabled={tabValue === index}
                style={{
                  backgroundColor: tabValue === index ? '#f5f5f5' : '#4a4a4a',
                  color: tabValue === index ? '#4a4a4a' : '#fff',
                  boxShadow: tabValue === index ? '0px 2px 10px 0 rgba(0, 0, 0, 0.15)' : 'none',
                  borderRadius: '4px 4px 0 0',
                  margin: index === tabs.length ? '0' : '0 5px 0 0',
                  opacity: '1',
                }}
              />
            );
          })}
        </Tabs>
        <div className='bookings-table'>
          {tabValue === 0 ? (
            <div className='bookings-table-search-area'>
              <div>
                <InputField className='bookings-pnr-code' ref='bookingsPnrCode' label='Label' placeholder={i18n('pnr')} inputType='docNumber' maxLength='6' validateMessage={bookingReferenceError} />
              </div>
              <div>
                <Select
                  id='bookingsArrivalStation'
                  ref='bookingsArrivalStation'
                  onChangeEvent={(data) => {
                    console.log(data);
                  }}
                  placeholder={i18n('flight_destination')}
                  isClearable
                  isDisabled={!flightOptionObject}
                  options={flightOptionObject}
                  defaultValue={''}
                />
              </div>
              <div>
                <DatePicker
                  ref='bookingsDate'
                  type={'single'}
                  beforeSelect={moment().add(-10, 'y').toDate()}
                  placeholder={i18n('booking_date')}
                  selectedEvent={(day, selected) => {
                    console.log(day);
                  }}
                />
              </div>
              <div>
                <Select
                  id='bookingsAgentId'
                  ref='bookingsAgentId'
                  onChangeEvent={(data) => {
                    console.log(data);
                  }}
                  placeholder={i18n('agent_id')}
                  isClearable
                  defaultValue={''}
                  isDisabled={!agentList}
                  options={agentList}
                />
              </div>
              <div>
                <Button className='bookings-search-button primary-button' onClick={onSearchBookings}>
                  <div>{i18n('search')}</div>
                </Button>
              </div>
            </div>
          ) : null}
          {bookingRows.length !== 0 ? (
            <Table
              rows={bookingRows}
              columns={creatColumns()}
              tablePage={tablePage}
              rowsPerPageOptions={[10, 20, 50, 100]}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          ) : (
            <div className='bookings-search-wording'>
              <img alt='' src={require('assets/images/search.svg')} />
              <div>{i18n('please_search_by_field')}</div>
            </div>
          )}
        </div>
        <Dialog
          dialogId='bookingDialog'
          maxWidth='xl'
          zIndex={2000}
          open={!!openBookingDialog}
          title={'Booking Details'}
          actionsClassName='booking-details-dialog'
          onClose={() => {
            this.setState(
              {
                openBookingDialog: false,
              },
              () => {
                setTimeout(() => {
                  dispatch(cleanBookingData());
                }, 300);
              }
            );
          }}
          onRequestClose={() => {
            this.setState(
              {
                openBookingDialog: false,
              },
              () => {
                setTimeout(() => {
                  dispatch(cleanBookingData());
                }, 300);
              }
            );
          }}
          actions={[]}
        >
          {/* ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ 訂位資料區塊 ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ */}
          {bookingData ? (
            <div className='bookings-confirmation-content'>
              {/* 預定確認單 */}
              <div className='bookings-confirmation-title'>
                <div>
                  <img alt='' src={require('assets/images/ic-management.svg')} />
                  <div>{i18n('booking_confirmation')}</div>
                </div>
                <div>{`${i18n('scheduled_date')}：${moment(bookingData.bookingDate.split('+')[0]).format('YYYY/MM/DD (dddd)')}`}</div>
              </div>
              {/* 訂位紀錄 */}
              <div className='bookings-confirmation-record'>
                <div className='bookings-confirmation-record-left'>
                  <div>{`${i18n('booking_record')}：`}</div>
                  <div>{bookingData.recordLocator}</div>
                </div>
                <div className='bookings-confirmation-record-right'>
                  <div>{`${i18n('scheduled_status')}：`}</div>
                  <div>{bookingData.status}</div>
                </div>
              </div>
              {/* 行程確認單 */}
              {Object.keys(bookingData.journeys).length !== 0 ? (
                <div className='bookings-confirmation-itinerary-title'>
                  <img alt='' src={require('assets/images/ic-itinerary.svg')} />
                  <div>{i18n('itinerary_confirmation')}</div>
                </div>
              ) : (
                <div>{i18n('no_flight_information')}</div>
              )}
              {/* 航班資料 */}
              {Object.keys(translationData).length !== 0 &&
                Object.keys(bookingData.journeys).length !== 0 &&
                Object.values(bookingData.journeys).map((item, index) => {
                  let showPHWording = false;
                  Object.keys(translationData[getLocale()].origindestination.PH).map((key) => {
                    item.segments.map((segmentsItem) => {
                      if (bookingData.segments[segmentsItem].departure.code === key || bookingData.segments[segmentsItem].arrival.code === key) {
                        showPHWording = true;
                      }
                      return true;
                    });
                    return true;
                  });
                  if (item.segments.length === 1) {
                    // 無轉機
                    return (
                      <div className='bookings-confirmation-airline-single' key={index}>
                        <div>{`${index === 0 ? '出發' : '回程'} (${bookingData.segments[item.segments[0]].productClassName})`}</div>
                        <div>
                          <div>
                            {`${bookingData.segments[item.segments[0]].departure.code} ${translationData[getLocale()].stations[bookingData.segments[item.segments[0]].departure.code].shortName}`}
                          </div>
                          <div></div>
                          <div>{`${bookingData.segments[item.segments[0]].arrival.code} ${translationData[getLocale()].stations[bookingData.segments[item.segments[0]].arrival.code].shortName}`}</div>
                        </div>
                        <div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div>{`${bookingData.segments[item.segments[0]].flightDesignator.carrierCode}${bookingData.segments[item.segments[0]].flightDesignator.flightNumber}`}</div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                        </div>
                        <div>
                          <div>
                            {`${moment(bookingData.segments[item.segments[0]].departure.dateTime.split('+')[0]).format('HH:mm')} - `}
                            {handleDatePlus(bookingData.segments[item.segments[0]].departure.dateTime, bookingData.segments[item.segments[0]].arrival.dateTime)}
                          </div>
                          <div>{moment(bookingData.segments[item.segments[0]].departure.dateTime.split('+')[0]).format('YYYY/MM/DD (ddd)')}</div>
                        </div>
                        {/* Code-share提示文字 */}
                        {bookingData.segments[item.segments[0]].productClassName === 'Code-share' ? <div style={{ color: '#ff1744' }}>{'共用班號航班的旅客請至德威航空櫃檯進行報到手續。'}</div> : null}
                        {/* 菲律賓出發、除了宿霧航段提示文字 */}
                        {showPHWording ? <div style={{ color: '#ff1744' }}>{'菲律賓航線未隨票徵收機場離境稅，旅客於菲律賓機場通關前需至收費櫃台支付。'}</div> : null}
                      </div>
                    );
                  } else {
                    // 轉機
                    return (
                      <div className='bookings-confirmation-airline-multi' key={index}>
                        <div>{`${index === 0 ? i18n('departure') : i18n('return')} (${bookingData.segments[item.segments[0]].productClassName})`}</div>
                        <div>
                          <div>
                            {`${bookingData.segments[item.segments[0]].departure.code} ${translationData[getLocale()].stations[bookingData.segments[item.segments[0]].departure.code].shortName}`}
                          </div>
                          <div>{`${bookingData.segments[item.segments[0]].arrival.code} ${translationData[getLocale()].stations[bookingData.segments[item.segments[0]].arrival.code].shortName}`}</div>
                          <div>{`${bookingData.segments[item.segments[1]].arrival.code} ${translationData[getLocale()].stations[bookingData.segments[item.segments[1]].arrival.code].shortName}`}</div>
                        </div>
                        <div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div>{`${bookingData.segments[item.segments[0]].flightDesignator.carrierCode}${bookingData.segments[item.segments[0]].flightDesignator.flightNumber}`}</div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div>
                            <img alt='' src={require('assets/images/ic-connect.svg')} />
                          </div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div>{`${bookingData.segments[item.segments[1]].flightDesignator.carrierCode}${bookingData.segments[item.segments[1]].flightDesignator.flightNumber}`}</div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                          <div className={`bookings-confirmation-${bookingData.segments[item.segments[0]].productClassName}`}></div>
                        </div>
                        <div>
                          <div></div>
                          <div>
                            <div>
                              {`${moment(bookingData.segments[item.segments[0]].departure.dateTime.split('+')[0]).format('HH:mm')} - `}
                              {handleDatePlus(bookingData.segments[item.segments[0]].departure.dateTime, bookingData.segments[item.segments[0]].arrival.dateTime)}
                            </div>
                            <div>{moment(bookingData.segments[item.segments[0]].departure.dateTime.split('+')[0]).format('YYYY/MM/DD (ddd)')}</div>
                          </div>
                          <div>tigerconnect</div>
                          <div>
                            <div>
                              {`${moment(bookingData.segments[item.segments[1]].departure.dateTime.split('+')[0]).format('HH:mm')} - `}
                              {handleDatePlus(bookingData.segments[item.segments[1]].departure.dateTime, bookingData.segments[item.segments[1]].arrival.dateTime)}
                            </div>
                            <div>{moment(bookingData.segments[item.segments[1]].departure.dateTime.split('+')[0]).format('YYYY/MM/DD (ddd)')}</div>
                          </div>
                          <div></div>
                        </div>
                        {/* Code-share提示文字 */}
                        {bookingData.segments[item.segments[0]].productClassName === 'Code-share' ? <div style={{ color: '#ff1744' }}>{i18n('code_share_wording')}</div> : null}
                        {/* 菲律賓出發、除了宿霧航段提示文字 */}
                        {showPHWording ? <div style={{ color: '#ff1744' }}>{i18n('philippines_wording')}</div> : null}
                      </div>
                    );
                  }
                })}
              {/* 付費機上服務 */}
              {Object.keys(bookingData.journeys).length !== 0 ? (
                <div className='bookings-confirmation-addons-title'>
                  <img alt='' src={require('assets/images/ic-airplane-plus.svg')} />
                  <div>{i18n('paid_onboard_service')}</div>
                </div>
              ) : null}
              {/* 旅客資料 */}
              {Object.keys(bookingData.journeys).length !== 0 ? (
                <div className='bookings-confirmation-passenger'>
                  <div className='bookings-confirmation-passenger-title'>
                    <div>{i18n('passenger_information')}</div>
                    <div>
                      <img alt='' src={require('assets/images/ic-baggage.svg')} />
                    </div>
                    <div>
                      <img alt='' src={require('assets/images/ic-meal.svg')} />
                    </div>
                    <div>
                      <img alt='' src={require('assets/images/ic-seat.svg')} />
                    </div>
                    <div>
                      <img alt='' src={require('assets/images/ic-faq.svg')} />
                    </div>
                  </div>
                  <div>
                    {Object.keys(translationData).length !== 0 &&
                      Object.keys(bookingData.journeys).length !== 0 &&
                      Object.values(bookingData.journeys).map((item, index) => {
                        return (
                          <div key={index}>
                            {item.segments.map((segmentsItem, segmentsIndex) => {
                              return (
                                <Fragment key={segmentsIndex}>
                                  {Object.keys(bookingData.addOns[segmentsItem]).length > 0 ? (
                                    Object.keys(bookingData.addOns[segmentsItem]).map((addOnsKey, addOnsIndex) => {
                                      return (
                                        <div key={addOnsIndex} className='bookings-confirmation-passenger-cell'>
                                          <div>
                                            <div>{addOnsIndex === 0 ? segmentsItem.substr(9, 6).replace(' ', '') : null}</div>
                                            <div>{bookingData.passengers[addOnsKey].name.title.toLowerCase()}</div>
                                            <div>
                                              <span style={{ fontWeight: 900 }}>{`${bookingData.passengers[addOnsKey].name.firstName} ${bookingData.passengers[addOnsKey].name.lastName}`}</span>
                                              {bookingData.passengers[addOnsKey].memberNumber !== '' ? ` (member ID ${bookingData.passengers[addOnsKey].memberNumber})` : ''}
                                              {bookingData.passengers[addOnsKey].infant
                                                ? ` with infant (${bookingData.passengers[addOnsKey].infant.title} ${bookingData.passengers[segmentsIndex].infant.firstName} ${bookingData.passengers[segmentsIndex].infant.lastName})`
                                                : ''}
                                            </div>
                                          </div>
                                          <div>
                                            {translationData[getLocale()].ssrcodes[bookingData.addOns[segmentsItem][addOnsKey].baggage]
                                              ? translationData[getLocale()].ssrcodes[bookingData.addOns[segmentsItem][addOnsKey].baggage].name
                                              : '-'}
                                          </div>
                                          <div>
                                            {bookingData.addOns[segmentsItem][addOnsKey].meals.map((mealItem, mealIndex) => {
                                              return <div key={mealIndex}>{translationData[getLocale()].ssrcodes[mealItem] ? translationData[getLocale()].ssrcodes[mealItem].name : mealItem}</div>;
                                            })}
                                            {bookingData.addOns[segmentsItem][addOnsKey].meals.length === 0 ? '-' : ''}
                                          </div>
                                          <div>{bookingData.addOns[segmentsItem][addOnsKey].seat ? bookingData.addOns[segmentsItem][addOnsKey].seat : '-'}</div>
                                          <div>
                                            {bookingData.addOns[segmentsItem][addOnsKey].others.map((otherItem, otherIndex) => {
                                              return <div key={otherIndex}>{translationData[getLocale()].ssrcodes[otherItem] ? translationData[getLocale()].ssrcodes[otherItem].name : otherItem}</div>;
                                            })}
                                            {bookingData.addOns[segmentsItem][addOnsKey].others.length === 0 ? '-' : ''}
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <div className='bookings-confirmation-passenger-cell'>
                                      <div>
                                        <div>{segmentsItem.substr(9, 6).replace(' ', '')}</div>
                                        <div>{bookingData.passengers[0].name.title.toLowerCase()}</div>
                                        <div>
                                          <span style={{ fontWeight: 900 }}>{`${bookingData.passengers[0].name.firstName} ${bookingData.passengers[0].name.lastName}`}</span>
                                          {bookingData.passengers[0].memberNumber !== '' ? ` (member ID ${bookingData.passengers[0].memberNumber})` : ''}
                                          {bookingData.passengers[0].infant
                                            ? ` with infant (${bookingData.passengers[0].infant.title} ${bookingData.passengers[segmentsIndex].infant.firstName} ${bookingData.passengers[segmentsIndex].infant.lastName})`
                                            : ''}
                                        </div>
                                      </div>
                                      <div>-</div>
                                      <div>-</div>
                                      <div>-</div>
                                      <div>-</div>
                                    </div>
                                  )}
                                </Fragment>
                              );
                            })}
                          </div>
                        );
                      })}
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
          {/* ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ 訂位資料區塊 ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ */}
        </Dialog>
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    state: state.homeReducer,
    translationData: state.mainReducer.translationData,
  };
};

export default connect(mapStateToProps)(BookingsControl);
